import React, { Component } from 'react';
import classNames from 'classnames';

import './button.css';

export default class ButtonHeader extends Component {
  render() {
    const { text, onClick } = this.props;
    let typeButton = null;
    switch (this.props.type) {
      case 'finish':
        typeButton = 'button-finish'
        break;
      case 'email':
        typeButton = 'button-email'
        break;
      case 'login':
        typeButton = 'button-login'
        break;

      default:
        typeButton = 'button-cancel'
        break;
    }
    return (
      <button id={typeButton}
        className={classNames(
          this.props.styleButton,
          typeButton
        )}
        onClick={onClick}>
        <p>{text}&nbsp;&nbsp;&nbsp;<span className="arrow-down"></span></p>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/components/Button/Button.js